import React, { useCallback } from "react"

interface SimilarProps {
  similarCount: number | undefined
  onClick: (event: React.MouseEvent) => void
}
export const ShowSimilar: React.FunctionComponent<SimilarProps> = ({ similarCount, onClick }) => {
  const handleOnClick = useCallback(onClick, [])
  return similarCount && similarCount > 0 ? (
    <div className="photoselector-overlay-similar" onClick={handleOnClick} data-tam="overlay-similar">
      x{similarCount}
    </div>
  ) : null
}
